module.exports = __webpack_public_path__ + "img/logo_logistics.f8304609.png";